const BANNER_HEIGHT = '48px'

export { BANNER_HEIGHT }
